import React from "react"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { SUPPLIER_ADMIN_ADMINISTRATORS_CREATE_ROUTE, SUPPLIER_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { SupplierAdministratorsTable } from "../components/SupplierAdministratorsTable"
import { Button } from "../../../../../office/admin/components/Button"
import { useNavigate } from "react-router-dom"

export function SupplierAdministrators() {
    const navigate = useNavigate()

    return (
        <>
            <LocalizedStrict id="supplier-users-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_ACCOUNT_ADMINISTRATORS}
                    title="Administrators"
                    icon={<FontAwesomeIcon icon={faInfoCircle} />}
                    rightElement={
                        <LocalizedStrict id="supplier-users-create-admin-button">
                            <Button
                                variant="contained"
                                onClick={() => {
                                    navigate(SUPPLIER_ADMIN_ADMINISTRATORS_CREATE_ROUTE)
                                }}
                            >
                                Create admin
                            </Button>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-update-account-nav-item-account">
                            <Breadcrumb>Account</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-administrators">
                            <Breadcrumb>Administrators</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <SupplierAdministratorsTable />
        </>
    )
}
